import {Injectable} from '@angular/core';
import {STORAGE_KEY_BENEFICIAIRE, STORAGE_KEY_CE, STORAGE_KEY_USER, STORAGE_KEY_VERSION} from './storage/constant-key';
import moment from 'moment';

@Injectable()
export class LocalStorageService {
  private keyOauthLocalStorage = 'oauth-data';
  private keyExpireLocalStorage = 'oauth-expire';
  private keyTotalCartLocalStorage = 'totalCart';
  private keySourceDeDonneesLocalStorage = 'afpa';
  private keyCeLocalStorage = STORAGE_KEY_CE;
  private keyUserLocalStorage = STORAGE_KEY_USER;
  private keyVersionLocalStorage = STORAGE_KEY_VERSION;
  private keyDateDossierLocalStorage = 'dateDossier';

  constructor() {
    console.warn('The \'LocalStorageService\' class is deprecated and will be removed. Create a dedicated class instead.');
  }

  getOauthToken() {
    return JSON.parse(localStorage.getItem(this.keyOauthLocalStorage));
  }

  setOauthToken(data) {
    localStorage.setItem(this.keyOauthLocalStorage, JSON.stringify(data));
    localStorage.setItem(this.keyExpireLocalStorage, new Date().getTime().toString());
  }

  removeOauthToken() {
    localStorage.removeItem(this.keyOauthLocalStorage);
    localStorage.removeItem(this.keyExpireLocalStorage);
    this.removeBeneficiaire();
    this.removeCe();
    this.removeUser();
  }

  getExpireOauthToken() {
    return localStorage.getItem(this.keyExpireLocalStorage);
  }

  /**
   * @deprecated The "getBeneficiaire()" method is deprecated and will be removed. Use the BeneficiaireContextService::get() method instead.
   * @returns {any}
   */
  getBeneficiaire() {
    console.warn('The "getBeneficiaire()" method is deprecated and will be removed. Use the BeneficiaireContextService::get()' +
      ' method instead.');
    return JSON.parse(localStorage.getItem(STORAGE_KEY_BENEFICIAIRE));
  }

  removeBeneficiaire() {
    localStorage.removeItem(STORAGE_KEY_BENEFICIAIRE);
    localStorage.removeItem(this.keyTotalCartLocalStorage);
  }

  getUser() {
    return JSON.parse(localStorage.getItem(this.keyUserLocalStorage));
  }

  removeUser() {
    localStorage.removeItem(this.keyUserLocalStorage);
  }

  setTotalCart(total) {
    localStorage.setItem(this.keyTotalCartLocalStorage, JSON.stringify(total));
  }

  getTotalCart() {
    return JSON.parse(localStorage.getItem(this.keyTotalCartLocalStorage));
  }

  setSourceDeDonnees(total) {
    localStorage.setItem(this.keySourceDeDonneesLocalStorage, JSON.stringify(total));
  }

  getSourceDeDonnees() {
    return JSON.parse(localStorage.getItem(this.keySourceDeDonneesLocalStorage));
  }

  /**
   * @deprecated The "setCe()" method is deprecated and will be removed. Use the CeContextService::set() method instead.
   * @returns {any}
   */
  setCe(code) {
    console.warn('The "setCe()" method is deprecated and will be removed. Use the CeContextService::set() method instead.');
    localStorage.setItem(this.keyCeLocalStorage, JSON.stringify(code));
  }

  /**
   * @deprecated The "getCe()" method is deprecated and will be removed. Use the CeContextService::get() method instead.
   * @returns {any}
   */
  getCe() {
    console.warn('The "getCe()" method is deprecated and will be removed. Use the CeContextService::get() method instead.');
    return JSON.parse(localStorage.getItem(this.keyCeLocalStorage));
  }

  removeCe() {
    localStorage.removeItem(this.keyCeLocalStorage);
  }

  setDateDossier(date: string): void {
    const stringDate = moment(date).format('YYYY-MM-DD');
    localStorage.setItem(this.keyDateDossierLocalStorage, stringDate);
  }

  getDateDossier(): string | null {
    const item = localStorage.getItem(this.keyDateDossierLocalStorage);
    if (!item) {
      return null;
    }
    return item;
  }

  removeDateDossier(): void {
    localStorage.removeItem(this.keyDateDossierLocalStorage);
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/localStorage.service.ts